export default __webpack_public_path__ + "static/media/spec-drawer.76d83947.png";